import { ReportDetailsSheet } from '../interfaces/report-details-sheet.interface';
import { ReportSheet } from '../interfaces/report-sheet.interface';

const nonStandardSheets = ['Report Details'];
const columnsNotToFormat = ['ID', 'Employees on Payroll', 'Employees', 'CRA', 'Period'];
export class ReportBook {
    get sheets(): ReportSheet[] {
        return this._sheets.filter((sheet) => !nonStandardSheets.includes(sheet.title));
    }

    get hasMoreThanOneSheet(): boolean {
        return this.sheets.length > 1;
    }

    get reportDetails(): ReportDetailsSheet {
        const reportDetailsSheet: ReportSheet = this._sheets.find((sheet) => sheet.title === 'Report Details');

        if (!reportDetailsSheet) {
            throw new Error('Report is missing Report Details sheet');
        }

        const row = reportDetailsSheet.rows[0];

        return {
            businessName: row[0],
            doingBusinessNameAs: row[1],
            reportRunOn: row[2],
            paySchedule: row[3],
            includesPendingPayrolls: row[4] === 'Yes' ? true : false,
            period: row[5],
        };
    }

    columnsNotToFormat: number[][];
    private _sheets: ReportSheet[];

    constructor(attributes: any) {
        this._sheets = attributes.sheets;
    }

    formatForDisplay(): this {
        this.removeEmptyColumns();
        this.setColumnsNotToFormat();

        return this;
    }

    /**
     * Remove empty columns that were originally added to make the excel look nicer
     */
    private removeEmptyColumns() {
        const columnsToRemove = this.sheets.map(({ headings }) =>
            headings
                .map((heading, index) => (heading === '' ? index : -1))
                .filter((headingIndex: number) => headingIndex > -1)
        );

        columnsToRemove.forEach((sheetColumnsToRemove, sheetIndex) => {
            const sheet = this.sheets[sheetIndex];

            sheet.headings = sheet.headings.filter((_, index) => !sheetColumnsToRemove.includes(index));
            sheet.rows = sheet.rows.map((row) => row.filter((_, index) => !sheetColumnsToRemove.includes(index)));
        });
    }

    /** This is a 4th quarter hack to do make sure we don't format
     * certain columns
     */
    private setColumnsNotToFormat() {
        this.columnsNotToFormat = this.sheets.map(({ headings }) =>
            headings
                .map((heading, headingIndex) => (columnsNotToFormat.includes(heading) ? headingIndex : -1))
                .filter((headingIndex) => headingIndex > -1)
        );
    }
}
